import { sortBy, toString } from 'lodash';
import { AUTOCOMPLETE_SUCCESS } from '../../constants';
import { getTypedValue, isPlanRequest } from './helpers';
import dropdownStateSelector from '../dropdown-state/dropdownStateSelector';
import { cleanPlan } from './cleanPlan';

const getHighlight = (toHighlight, textToHighlightRegex) => {
    if (toHighlight) {
        return toHighlight.replace(textToHighlightRegex, '<em>$&</em>');
    }

    return toHighlight;
};

const addExactMatch = ({
    loweredTypedValue, parsedPlan, exact, isTop,
}) => {
    if (parsedPlan.plan_id && !isTop) {
        const exactMatch = `${parsedPlan.carrier_name.toLowerCase()} ${parsedPlan.plan_name.toLowerCase()}`;
        if (exactMatch.indexOf(loweredTypedValue) === 0) {
            exact.push(parsedPlan);
        }
    }
};

export function transformResponse(json, state) {
    const dropdownState = dropdownStateSelector(state);
    const apiOutput = json;
    const carriers = [];
    const plans = [];
    const exact = [];

    const typedValue = getTypedValue(state);
    const loweredTypedValue = typedValue.toLowerCase();

    if (apiOutput.length > 0) {
        const textToHighlightRegex = new RegExp(typedValue, 'gi');

        apiOutput.forEach(item => {
            if (item.plan_id) {
                const carrierNameRegex = new RegExp(item.carrier_name, 'gi');
                const displayCarrierName = isPlanRequest(dropdownState) ? '' : `${item.carrier_name} - `;
                let planNameReplaced = cleanPlan(item.plan_name, carrierNameRegex);

                if (planNameReplaced === '') {
                    planNameReplaced = item.plan_name || item.carrier_name;
                }

                const planNameHighlighted = getHighlight(planNameReplaced, textToHighlightRegex);

                const parsedPlan = {
                    ...item,
                    id: toString(item.plan_id),
                    name: `${displayCarrierName}${planNameHighlighted}`,
                    rawName: `${displayCarrierName}${planNameReplaced}`,
                    displayPlanName: planNameReplaced,
                };

                plans.push(parsedPlan);

                addExactMatch({
                    loweredTypedValue,
                    parsedPlan,
                    exact,
                    isTop: plans.length <= 2,
                });
            } else {
                carriers.push({
                    ...item,
                    id: toString(item.carrier_id),
                    name: getHighlight(item.carrier_name, textToHighlightRegex),
                    rawName: item.carrier_name,
                });
            }
        });
    }

    return {
        type: AUTOCOMPLETE_SUCCESS,
        payload: {
            result: {
                carriers: sortBy(carriers, ['rawName']),
                plans: sortBy(plans, ['rawName']),
                top: carriers
                    .slice(0, 2)
                    .concat(plans.slice(0, 2))
                    .concat(exact.slice(0, 2)),
            },
        },
    };
}
